/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react'
import styles from './chartcontrol.module.scss'

export default function ChartControl({
  showChartIncome,
  setShowChartIncome,
  showChartExpenses,
  setShowChartExpenses,
  t
}) {
  return (
    <div className={styles.chart_control}>
      <h3 className={styles.chart_title}>{t('income_history')}</h3>
      <div className={styles.chart_control_buttons}>
        <div className={styles.inc_ex_control_panel}>
          <button
            className={`${styles.chart_control_button_inc_exp} ${showChartIncome ? styles.active_inc_exp : ''}`}
            onClick={() => setShowChartIncome(!showChartIncome)}
          >
            {t('income')}
          </button>
          <button
            className={`${styles.chart_control_button_inc_exp} ${showChartExpenses ? styles.active_inc_exp : ''}`}
            onClick={() => setShowChartExpenses(!showChartExpenses)}
          >
            {t('expenses')}
          </button>
        </div>
      </div>
    </div>
  )
}
